// Interaktívna mapa okolia na stránke Lokalita.
// Dáta prichádzajú z templates/parts/location-places.php cez window.javorMapData.
const MAP_ZOOM = 17
const MIN_ZOOM = 15
// polomer (v stupňoch) pre body, na ktoré sa mapa zarovná po načítaní
const NEAR_RADIUS = 0.02
const PIN_W = 44
const PIN_H = 56
const PROJECT_H = 53
const CARD_WIDTH = 247
const CARD_OFFSET_X = -45

// ikony kategórií (24×24)
const ICONS = {
    doprava: "M12 2c-4 0-8 .5-8 4v9.5A3.5 3.5 0 0 0 7.5 19L6 20.5v.5h12v-.5L16.5 19a3.5 3.5 0 0 0 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM11 10H6V6h5v4zm2 0V6h5v4h-5zm3.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z",
    obchody: "M18 6h-2a4 4 0 0 0-8 0H6a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-6-2a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2z",
    zdravie: "M13 3h-2a1 1 0 0 0-1 1v6H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6V4a1 1 0 0 0-1-1z",
    vzdelavanie: "M12 3 1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z",
    sport: "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-1.33-1.78L7 18h14L14 6zM5 16l1.52-2.03L5.04 12 1 18h6.5L5 16z",
    hotely: "M7 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9a4 4 0 0 0-4-4z",
    gastro: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z",
    kultura: "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z",
}

const WALK_ICON = "M13.5 5.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM9.8 8.9 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3A7.3 7.3 0 0 0 19 13v-2c-1.8 0-3.3-.9-4.1-2.2l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7z"
const CAR_ICON = "M18.9 6c-.2-.6-.8-1-1.4-1H6.5c-.7 0-1.2.4-1.4 1L3 12v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8l-2.1-6zM6.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5 11l1.5-4.5h11L19 11H5z"

const LOGO_PATHS = [{"d": "M71.3517 32.0324L67.0164 29.1756L70.5956 27.622C71.3517 27.3213 71.6542 26.4693 71.3517 25.7175C71.0493 24.9658 70.1923 24.6651 69.4361 24.9658L65.857 26.5194L66.714 21.4074C66.8652 20.6055 66.3107 19.9039 65.5041 19.7535C64.748 19.6032 63.9918 20.1545 63.8406 20.9564L62.6811 27.8726L58.6987 29.6267L59.9085 22.4599C60.0598 21.658 59.5053 20.9564 58.6987 20.806C57.8921 20.6556 57.1864 21.2069 57.0351 22.0088L55.5228 31.03L50.6834 33.1349L52.1453 24.4646C52.2965 23.6627 51.742 22.9611 50.9354 22.8107C50.1289 22.6604 49.4231 23.2116 49.2719 24.0135L47.5075 34.5382L38.3328 38.4975V34.2876L47.2555 28.3236C47.9108 27.8726 48.1124 26.9705 47.6587 26.3189C47.205 25.6674 46.2977 25.4669 45.6423 25.918L38.2824 30.8295V25.6173L47.2555 19.6032C47.9108 19.1521 48.1124 18.25 47.6587 17.5985C47.205 16.9469 46.2977 16.7465 45.6423 17.1975L38.1815 22.1592V16.8968L45.8944 11.7848C46.5497 11.3338 46.7514 10.4317 46.2977 9.78012C45.844 9.12859 44.9366 8.92812 44.2812 9.37918L38.1311 13.4387V9.07847L44.0292 5.1693C44.6845 4.71824 44.8862 3.81612 44.4325 3.16459C43.9788 2.51306 43.0714 2.31259 42.416 2.76365L38.0807 5.62036V1.71118C38.0807 0.909299 37.375 0.257769 36.6188 0.307886C35.8122 0.307886 35.1569 0.959416 35.2073 1.7613V5.62036V9.02836V13.3385L35.2577 16.7465V21.9587L35.3081 25.3667L35.5098 59.5971C35.5098 60.3989 36.1651 61.0003 36.9717 61.0003C37.7783 61.0003 38.4336 60.3488 38.3832 59.5469V56.5399L42.164 59.2462C42.416 59.4467 42.7185 59.4968 43.021 59.4968C43.4747 59.4968 43.9284 59.2963 44.1804 58.8954C44.6341 58.2439 44.4829 57.3418 43.8275 56.8907L38.2824 52.9314V44.5618C38.232 44.5618 42.7689 47.1679 42.7689 47.1679L43.1722 54.034C43.1722 54.6855 43.7771 55.1867 44.4325 55.1867C45.0878 55.1867 44.4325 55.1867 44.4829 55.1867C45.1886 55.1867 45.6927 54.5853 45.6423 53.8836L45.3399 48.6213L47.7596 49.9745L48.1124 55.8382C48.1124 56.4898 48.7174 56.9909 49.3727 56.9909C50.028 56.9909 49.3727 56.9909 49.4231 56.9909C50.1289 56.9909 50.633 56.3895 50.5826 55.6879L50.3305 51.4279L52.1957 52.5305L52.4478 56.9909C52.4478 57.6425 53.0527 58.1436 53.708 58.1436C54.3634 58.1436 53.708 58.1436 53.7584 58.1436C54.4642 58.1436 54.9683 57.5422 54.9179 56.8406L54.7666 53.9839L56.531 54.9862C56.7327 55.0865 56.9343 55.1366 57.1359 55.1366C57.5896 55.1366 57.9929 54.9361 58.1946 54.5352C58.5474 53.9338 58.3458 53.182 57.7409 52.8312L55.9765 51.8288L58.5474 50.5258C59.1524 50.2251 59.4044 49.4733 59.102 48.8719C58.7995 48.2705 58.0433 48.0199 57.4384 48.3206L53.456 50.3754L51.5908 49.2728L55.422 47.3182C56.0269 47.0175 56.279 46.2658 55.9765 45.6644C55.674 45.0629 54.9179 44.8124 54.313 45.1131L49.0702 47.7693L46.6505 46.4161L51.3387 44.0105C51.9437 43.7098 52.1957 42.958 51.8932 42.3566C51.5908 41.7552 50.8346 41.5046 50.2297 41.8053L44.0796 44.9126L38.2824 41.6048V41.3542L48.6166 36.8938L57.5896 42.7575C57.8417 42.9079 58.0938 43.0081 58.3962 43.0081C58.8499 43.0081 59.3036 42.7575 59.6061 42.3566C60.0598 41.7051 59.8581 40.8029 59.2028 40.3519L51.7924 35.5406L56.6318 33.4356L64.3447 38.4474C64.5967 38.5978 64.8488 38.698 65.1512 38.698C65.6049 38.698 66.0586 38.4474 66.3611 38.0465C66.8148 37.3949 66.6131 36.4928 65.9578 36.0418L59.8581 32.0324L63.8406 30.2782L69.7386 34.1874C69.9907 34.3378 70.2427 34.438 70.5452 34.438C70.9989 34.438 71.4526 34.2375 71.755 33.7865C72.2087 33.1349 72.0071 32.2328 71.3517 31.7818V32.0324Z", "evenodd": false}, {"d": "M32.9843 0C32.8835 0 32.6314 0 32.3794 0C31.5728 0 30.8166 0.551294 30.4134 1.25294L24.112 12.5294C23.9104 12.9304 23.4567 13.0807 23.0534 12.9805L18.9701 11.8779C18.3148 11.6774 17.7099 12.3289 17.8107 13.0306L19.9279 23.856C20.1296 24.8584 18.9197 25.4598 18.2644 24.6579L13.7778 18.7941C13.3241 18.1927 12.4167 18.3431 12.1647 19.0948L11.0557 22.4527C10.9044 22.8537 10.5516 23.1544 10.0979 23.1042L0.97353 22.5529C0.318191 22.5529 -0.185915 23.2045 0.0661384 23.9061L3.84694 34.1802C3.99817 34.5311 3.89735 34.932 3.64529 35.2327L1.17517 37.9391C0.721477 38.4402 0.872708 39.2421 1.47764 39.4927L15.4918 46.1082C15.9455 46.3087 16.1471 46.9101 15.9455 47.4113L13.6266 53.0746C13.3241 53.7762 13.8787 54.528 14.6348 54.4278L29.5564 52.2727C30.1613 52.1725 30.6654 52.6737 30.615 53.3252L30.2117 60.8428H32.9339V0H32.9843Z", "evenodd": true}]

const COLORS = { pin: "#E2D3A1", pinActive: "#CAB288", icon: "#1C5D86", white: "#ffffff" }

// Svetlý štýl mapy podľa predlohy: teplé šedé plochy, viditeľné budovy,
// biele cesty, šedé názvy miest a bez farebných ikon Google (kolidovali by so značkami).
const MAP_STYLE = [
    { elementType: "geometry", stylers: [{ color: "#efedea" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#918c85" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }, { weight: 3 }] },

    { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#7c7871" }] },

    // budovy dávajú mape kresbu
    { featureType: "landscape.man_made", elementType: "geometry.fill", stylers: [{ color: "#e3dfd7" }] },
    { featureType: "landscape.man_made", elementType: "geometry.stroke", stylers: [{ color: "#cec8be" }] },
    { featureType: "landscape.natural", elementType: "geometry.fill", stylers: [{ color: "#ebe9e4" }] },
    { featureType: "landscape.natural.terrain", stylers: [{ visibility: "off" }] },

    // z bodov záujmu necháme len šedé názvy
    { featureType: "poi", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#a09b93" }] },
    { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#e1e6da" }] },

    // cesty biele s jemným obrysom
    { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#e2ded7" }] },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9e998f" }] },
    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#d9d3ca" }] },

    // železnica ako tmavšia linka
    { featureType: "transit.line", elementType: "geometry.fill", stylers: [{ color: "#b3ada4" }] },
    { featureType: "transit.line", elementType: "geometry.stroke", stylers: [{ color: "#b3ada4" }] },
    { featureType: "transit.station", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "transit.station", elementType: "geometry.fill", stylers: [{ color: "#dfdad2" }] },

    { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#d5dee2" }] },
]

function pinIcon( category, active ) {
    const path = ICONS[ category ] || ICONS.obchody
    const fill = active ? COLORS.pinActive : COLORS.pin
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${PIN_W}" height="${PIN_H}" viewBox="0 0 44 56">
        <path d="M22 55C22 55 42 33.9 42 21.6 42 10.2 33 1 22 1S2 10.2 2 21.6C2 33.9 22 55 22 55Z" fill="${fill}"/>
        <g transform="translate(10 10)" fill="${COLORS.icon}"><path d="${path}"/></g>
    </svg>`

    return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent( svg ),
        scaledSize: new google.maps.Size( PIN_W, PIN_H ),
        anchor: new google.maps.Point( PIN_W / 2, PIN_H ),
    }
}

function projectIcon() {
    const w = 62
    const h = PROJECT_H
    const paths = LOGO_PATHS.map( function( item ) {
        return `<path d="${item.d}"${item.evenodd ? ' fill-rule="evenodd" clip-rule="evenodd"' : ''}/>`
    }).join( "" )

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 72 61">
        <g fill="${COLORS.icon}">${paths}</g>
    </svg>`

    return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent( svg ),
        scaledSize: new google.maps.Size( w, h ),
        anchor: new google.maps.Point( w / 2, h / 2 ),
    }
}

// karta s informáciami – vlastný overlay, aby sa dala plne naštýlovať
function createCard( map ) {
    const Card = class extends google.maps.OverlayView {
        constructor() {
            super()
            this.div = document.createElement( "div" )
            this.div.className = "location-map--card"
            this.position = null
        }

        onAdd() {
            this.getPanes().floatPane.appendChild( this.div )
        }

        onRemove() {
            if ( this.div.parentNode ) this.div.parentNode.removeChild( this.div )
        }

        show( place, position ) {
            this.position = position
            this.div.innerHTML = `
                <p class="location-map--card--title">${place.name}</p>
                <p class="location-map--card--distance">${place.distance || ""}</p>
                ${place.walk || place.drive ? `<div class="location-map--card--times">
                    ${place.walk ? `<span><svg viewBox="0 0 24 24"><path d="${WALK_ICON}"/></svg>${place.walk}</span>` : ""}
                    ${place.drive ? `<span><svg viewBox="0 0 24 24"><path d="${CAR_ICON}"/></svg>${place.drive}</span>` : ""}
                </div>` : ""}`
            // vzdialenosť bodu ukotvenia od horného / spodného okraja ikony:
            // špendlík je ukotvený na špičke, logo projektu v strede
            this.iconAbove = place.isProject ? PROJECT_H / 2 : PIN_H
            this.iconBelow = place.isProject ? PROJECT_H / 2 : 0
            this.div.classList.add( "is-visible" )
            this.draw()
        }

        hide() {
            this.div.classList.remove( "is-visible" )
        }

        draw() {
            if ( !this.position ) return

            const p = this.getProjection().fromLatLngToDivPixel( this.position )
            const mapWidth = map.getDiv().offsetWidth
            const overlay = this.getProjection().fromLatLngToContainerPixel( this.position )

            // karta visí pod značkou vpravo; pri pravom okraji sa preklopí doľava,
            // pri spodnom okraji (ak je hore miesto) sa presunie nad ikonu
            const mapHeight = map.getDiv().offsetHeight
            const cardHeight = this.div.offsetHeight
            const above = overlay.y + this.iconBelow + cardHeight > mapHeight - 16
                && overlay.y - this.iconAbove - cardHeight > 16

            this.div.classList.toggle( "is-flipped", overlay.x + CARD_OFFSET_X + CARD_WIDTH > mapWidth - 16 )
            this.div.style.left = p.x + "px"
            this.div.style.top = ( above ? p.y - this.iconAbove - cardHeight : p.y + this.iconBelow ) + "px"
        }
    }

    const card = new Card()
    card.setMap( map )
    return card
}

function initLocationMap() {
    const el = document.getElementById( "location-map" )

    if ( !el || !window.javorMapData ) return

    const data = window.javorMapData
    const center = { lat: data.project.lat, lng: data.project.lng }

    const map = new google.maps.Map( el, {
        zoom: MAP_ZOOM,
        center: center,
        styles: MAP_STYLE,
        disableDefaultUI: true,
        zoomControl: true,
        gestureHandling: "cooperative",
        clickableIcons: false,
    })

    const card = createCard( map )

    // na zariadeniach s myšou sa karta ukáže už pri prejdení; klik ju pripne, aby ostala otvorená
    const canHover = window.matchMedia( "(hover: hover) and (pointer: fine)" ).matches
    let active = null
    let pinned = null

    // logo projektu ostáva vždy rovnaké, špendlíky sa pri aktivite podfarbia
    function setActiveIcon( marker, isActive ) {
        if ( !marker.place.isProject ) marker.setIcon( pinIcon( marker.place.category, isActive ) )
    }

    function showPlace( marker ) {
        if ( active && active !== marker ) setActiveIcon( active, false )

        setActiveIcon( marker, true )
        active = marker
        card.show( marker.place, marker.getPosition() )
    }

    function hidePlace() {
        card.hide()

        if ( active ) {
            setActiveIcon( active, false )
            active = null
        }
    }

    // na zariadeniach s myšou karta pri prejdení, klik ju pripne
    function bindCard( marker ) {
        marker.addListener( "click", function() {
            pinned = marker
            showPlace( marker )
        })

        if ( canHover ) {
            marker.addListener( "mouseover", function() {
                showPlace( marker )
            })

            // po odídení myšou sa vráti pripnutá karta, inak sa karta skryje
            marker.addListener( "mouseout", function() {
                if ( pinned ) showPlace( pinned )
                else hidePlace()
            })
        }
    }

    data.places.forEach( function( place ) {
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng( place.lat, place.lng ),
            map: map,
            icon: pinIcon( place.category, false ),
            // pri hoveri by natívny tooltip prehliadača duplikoval kartu
            title: canHover ? null : place.name,
            optimized: false,
        })

        marker.place = place
        bindCard( marker )
    })

    const projectMarker = new google.maps.Marker({
        position: center,
        map: map,
        icon: projectIcon(),
        title: canHover ? null : data.project.name,
        zIndex: 999,
        optimized: false,
    })

    projectMarker.place = {
        name: data.project.name,
        distance: data.project.subtitle || "",
        isProject: true,
    }
    bindCard( projectMarker )

    map.addListener( "click", function() {
        pinned = null
        hidePlace()
    })

    // po načítaní zarovnaj mapu tak, aby boli vidieť všetky body v okolí projektu
    const bounds = new google.maps.LatLngBounds()
    bounds.extend( center )

    data.places.forEach( function( place ) {
        const d = Math.abs( place.lat - center.lat ) + Math.abs( place.lng - center.lng )
        if ( d < NEAR_RADIUS ) bounds.extend( new google.maps.LatLng( place.lat, place.lng ) )
    })

    map.fitBounds( bounds, { top: 60, right: 40, bottom: 60, left: 40 } )

    // pri väčšom oddialení Google prestane kresliť budovy – mapa potom pôsobí prázdno
    google.maps.event.addListenerOnce( map, "idle", function() {
        if ( map.getZoom() < MIN_ZOOM ) map.setZoom( MIN_ZOOM )
    })
}

function whenGoogleReady( callback, tries ) {
    if ( window.google && window.google.maps && window.google.maps.Map ) return callback()
    if ( ( tries || 0 ) > 60 ) return

    setTimeout( function() { whenGoogleReady( callback, ( tries || 0 ) + 1 ) }, 100 )
}

$(document).ready( function() {
    if ( document.getElementById( "location-map" ) ) {
        whenGoogleReady( initLocationMap )
    }
})
